
const fetchStores = async (productSku) => {
  if (productSku){
    const dataMuleFIS = {
      country: Shopify.country,
      product: productSku,
      sales_channel: themeVariables.settings.onStockSalesChannel
    };

    const response = await fetch("/apps/proxy/findInStore", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataMuleFIS),
    });

    if (!response.ok) {
      const message = `An error has occurred Find In store: ${response.status}`;
      throw new Error(message);
    }

    const stores = await response.json();
    return stores;
  }

  return null;
}

const transformStoreHTML = (store, index, mailConf) => {
  const storeHasHours = store.opening_hours || store.opening_hours_2;
  const fresh = document.createElement('li');
  fresh.classList.add('fis-storeWrapper');
  fresh.innerHTML = `
    <div class="fis-storeInfo">
          <div class="fis-storeInfo-details">
              ${store.boutique_name ? `<div class="fis-storeName">${store.boutique_name.toUpperCase()}</div>` : ''}
              ${store.store_address ? `<div class="fis-address">${store.store_address.toLowerCase().replace(/\\n|\\r\\n|\\n\\r|\\r/g, '<br>')}</div>` : ''}
              ${store.phone_number ? `<div class="fis-phone">T. ${store.phone_number}</div>` : ''}
              ${store.email ? `<div class="fis-email">${store.email.toLowerCase()}</div>` : ''}
          </div>

          <div class="fis-storeInfo-cta">
            <a href="mailto:${store.email}${mailConf}">${themeVariables.strings.fisBookingCta}</a>
            ${storeHasHours ? `<button class="fis-btn-infos" data-index=${index} aria-label="expend infos">${themeVariables.strings.fisInfosCta}</button>` : ''}
          </div>
    </div>
    ${storeHasHours ? `<div class="fis-openings openings-${index}">
      <p>${themeVariables.strings.fisOpenings}</p>
      ${store.opening_hours ? store.opening_hours.replace(/\\n|\\r\\n|\\n\\r|\\r/g, '<br>') : ''} <br>
      ${store.opening_hours_2 ? store.opening_hours_2.replace(/\\n|\\r\\n|\\n\\r|\\r/g, '<br>') : '' }         
    </div>` : ''}
`;
  return fresh;
}

const fisCta =  document.querySelector('.store-available');
if (fisCta) {
    fisCta.addEventListener('click', async () => {
        const fisButton = fisCta.getElementsByTagName("button")[0];
        const productHandle = fisButton.dataset.productHandle || null
        const productVariantId = fisButton.dataset.variantId || null
        const productVariantSku = fisButton.dataset.variantSku || null

        const stores = await fetchStores(productVariantSku);

        let urlString = `${Shopify.routes.root}products/${productHandle}?section_id=api-find-in-store`
        urlString = productVariantId ? urlString+'&variant='+productVariantId : urlString;


        const response = await fetch(urlString);
        if (!response.ok) {
          const message = `An error has occurred Find In store: ${response.status}`;
          throw new Error(message);
        }

        const responseHTML = await response.text();
        const fresh = document.createElement('div');
        fresh.innerHTML = responseHTML;

        const storeListHTML = fresh.querySelector(".fis-stores-list");
        if (stores && stores?.stocks.length > 0) {
          stores.stocks.map((store, index) => {
            const storeHTML = transformStoreHTML(store.store, index, storeListHTML.dataset.mailConf);
            storeListHTML.appendChild(storeHTML);
          })
        }else{
          // No stock found for this SKU
          const freshNoStock = document.createElement('li');
          freshNoStock.classList.add('fis-storeWrapper');
          freshNoStock.innerHTML = `<div class='fis-no-stock'>${themeVariables.strings.fisNoStock}</div>`
          storeListHTML.appendChild(freshNoStock);
        }

        fisCta.parentElement.appendChild(fresh);
        displayInfoButton(fresh);
        fisButton.setAttribute("aria-busy", "false");

    })
}

const displayInfoButton = (fresh) => {
  const infoCta = fresh.querySelectorAll(".fis-btn-infos");

  if (infoCta) {
    for (const fisBtnInfo of infoCta) {
      fisBtnInfo.addEventListener('click' , (event)=> {
        const btnIndex = event.target.dataset.index;
        const opening = fresh.querySelector(".openings-"+btnIndex);
        if (opening.style.display === "block") {
          event.target.innerHTML = themeVariables.strings.fisInfosCta
          opening.style.display = "none";
        } else {
          event.target.innerHTML = themeVariables.strings.fisCloseCta
          opening.style.display = "block";
        } 
      }); 
    }
  }
  
}